import './StatusScreens.css';

const COPY = {
  offline: {
    eyebrow: 'Connection',
    title: 'No internet',
    body: 'You’re offline. Check your connection, then try again to continue shopping.',
    icon: '◌',
    primary: 'Retry',
  },
  slow: {
    eyebrow: 'Network',
    title: 'Slow connection',
    body: 'Things are taking longer than usual. You can keep waiting or retry when the line is steadier.',
    icon: '⋯',
    primary: 'Keep waiting',
  },
  denied: {
    eyebrow: 'Access',
    title: 'Permission denied',
    body: 'You don’t have access to this area. Sign in with the right account or head back to the store.',
    icon: '⊘',
    primary: 'Go home',
  },
  timeout: {
    eyebrow: 'Session',
    title: 'Session timed out',
    body: 'For your security, your session ended. Sign in again to pick up where you left off.',
    icon: '◷',
    primary: 'Sign in',
  },
};

export function StatusScreen({
  type = 'offline',
  mode = 'full',
  onPrimary,
  onSecondary,
  secondaryLabel = 'Dismiss',
}) {
  const c = COPY[type] || COPY.offline;
  return (
    <div className={`nv-status${mode === 'toast' ? ' nv-status--toast' : ''}`} role="alertdialog" aria-modal={mode === 'full'}>
      <div className="nv-status__card">
        <div className="nv-status__icon" aria-hidden>
          {c.icon}
        </div>
        <p className="nv-status__eyebrow">{c.eyebrow}</p>
        <h2 className="nv-status__title">{c.title}</h2>
        <p className="nv-status__copy">{c.body}</p>
        <div className="nv-status__actions">
          <button type="button" className="btn btn-primary" onClick={onPrimary}>
            {c.primary}
          </button>
          {onSecondary && (
            <button type="button" className="btn btn-ghost" onClick={onSecondary}>
              {secondaryLabel}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default StatusScreen;
